export const OKR_FORM_FIELD_SELECT_TYPES = {
  DEFAULT: 'default',
  SECONDARY: 'secondary'
}
